import { useGetUserFreeTrialsLeftData } from "@/services/api/userService"
import { FreeTrialsLeft } from "@/types/freeTrialsLeft"
import { getTrialStatus } from "@/utils/freeTrialStatus"
import { useEffect, useState } from "react"
import { useTranslation } from "./useTranslation/useTranslation"

const useFreeTrial = () => {
  const { translate } = useTranslation()
  const [freeTrialsLeft, setFreeTrialsLeft] = useState<FreeTrialsLeft | null>()

  const { data, isLoading } = useGetUserFreeTrialsLeftData()

  useEffect(() => {
    // null is an answer too: /users/me/trial returns it once the user has
    // upgraded, and the trial they were last seen on must not linger.
    if (!isLoading && data !== undefined) {
      setFreeTrialsLeft(data ? { freeTrial: data.freeTrial } : null)
    }
  }, [data, isLoading, translate])

  const status = getTrialStatus(freeTrialsLeft?.freeTrial)

  return {
    /** False while /users/me/trial is loading and once it answers null (a paying
     *  user): there is no trial to show, not even a 0 day one. */
    hasTrial: freeTrialsLeft != null,
    // 0 also stands in for an unknown clock; check isUnknown before showing it
    left: freeTrialsLeft?.freeTrial.freeTrialDurationLeftDays ?? 0,
    total: freeTrialsLeft?.freeTrial.totalFreeTrialDurationDays ?? 0,
    isExpired: status === "expired",
    /** The trial end cannot be determined: neither expired nor running as far
     *  as the UI can tell, so show neither the expiry nor a day count. */
    isUnknown: status === "unknown",
  }
}

export default useFreeTrial
